import { IMyListGroup } from '@models/IMyListListing';
import {
  getAllLikedIds,
  getMyListFromCookie,
  removeItemById,
  setMyListCookie,
} from '@utility/helpers/myListHelper';
import useOneTrustConsent from '@utility/hooks/useOneTrustConsent';
import { useEffect, useState } from 'react';

export const useMyList = (id: string) => {
  const [isLiked, setIsLiked] = useState(false);
  const [myList, setMyList] = useState<Array<IMyListGroup> | null>(null);
  const cookieConsent = useOneTrustConsent();
  const allowFunctionalCookies = cookieConsent.includes('Functional');

  useEffect(() => {
    refreshMyList();
  }, []);

  useEffect(() => {
    if (myList === null) return;

    const likedIds = getAllLikedIds(myList);

    setIsLiked(likedIds.includes(id));
    setMyListCookie(myList, allowFunctionalCookies);
  }, [myList]);

  const addToMyList = (
    selectedLists: { id: number; title: string }[],
  ): void => {
    const myListCurrent = getMyListFromCookie() ?? [];
    const myListIds = myListCurrent.map((listItem) => listItem.id);

    selectedLists.forEach((list) => {
      const listIndex = myListIds.indexOf(list.id);
      const existingListItem = myListCurrent[listIndex];

      // If list already exists then add id to it
      // Else add new list
      if (listIndex > -1 && existingListItem) {
        myListCurrent.splice(listIndex, 1, {
          ...existingListItem,
          items: [...existingListItem.items, id],
        });
      } else {
        myListCurrent.push({
          ...list,
          items: [id],
        });
      }
    });

    setMyList([...myListCurrent]);
  };

  const removeFromMyList = (): void => {
    const myListFromCookie = getMyListFromCookie() ?? [];
    const updatedList = removeItemById(id, myListFromCookie);

    setMyList([...updatedList]);
  };

  const refreshMyList = () => {
    const myListFromCookie = (getMyListFromCookie() ?? []).map((listItem) =>
      Object.fromEntries(
        Object.entries(listItem).map(([key, value]) => [
          key.toLowerCase(),
          value,
        ]),
      ),
    ) as IMyListGroup[];

    const likedIds = getAllLikedIds(myListFromCookie);

    setIsLiked(likedIds.includes(id));

    setMyList(myListFromCookie);
  };

  return { isLiked, addToMyList, removeFromMyList, myList, refreshMyList };
};
